import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../view/Login'
import Register from '../view/Register'
import Home from '../view/Home'
import http from '../api/httpRequest'
import * as auth from '../api/auth.js'
import i18n, { setLocale } from '../i18n'
// 安装路由
Vue.use(VueRouter);

const getQueryValue = (value) => {
  if (Array.isArray(value)) {
    return value[0] || '';
  }
  return value || '';
}

// 读取 URL 的 lang 参数(playlet 客服 iframe 传入),只认支持的语言,其余忽略
const IM_SUPPORTED_LANGS = ['zh', 'en', 'es', 'ar', 'pt', 'ja', 'ko', 'fa', 'tr', 'vi', 'th', 'ru'];
const getEntryLang = (route) => {
  const routeLang = getQueryValue(route.query && route.query.lang);
  const lang = routeLang || new URLSearchParams(window.location.search).get('lang') || '';
  return IM_SUPPORTED_LANGS.includes(lang) ? lang : '';
}

const getEntryUsername = (route) => {
  const routeUsername = getQueryValue(route.query && route.query.username);
  if (routeUsername) {
    return routeUsername;
  }
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('username') || '';
}

const removeSearchUsername = () => {
  const searchParams = new URLSearchParams(window.location.search);
  if (!searchParams.has('username')) {
    return;
  }
  searchParams.delete('username');
  const search = searchParams.toString();
  const url = `${window.location.pathname}${search ? '?' + search : ''}${window.location.hash}`;
  window.history.replaceState(null, '', url);
}

const router = new VueRouter({
  routes: [{
    path: "/",
    redirect: "/home/chat"
  },
  {
    name: "Login",
    path: '/login',
    component: Login
  },
  {
    name: "Register",
    path: '/register',
    component: Register
  },
  {
    name: "Home",
    path: '/home',
    component: Home,
    children: [
      {
        name: "Chat",
        path: "/home/chat",
        component: () => import("../view/Chat"),
      },
      {
        name: "Friend",
        path: "/home/friend",
        component: () => import("../view/Friend"),
      },
      {
        name: "GROUP",
        path: "/home/group",
        component: () => import("../view/Group"),
      }
    ]
  }
  ]

});

router.beforeEach((to, from, next) => {
  // 方案X:URL 带 lang 时以它为准(跟随 playlet 当前语言),覆盖本地记忆
  const lang = getEntryLang(to);
  if (lang && i18n.locale !== lang) {
    setLocale(lang);
  }
  const username = getEntryUsername(to);
  // 带 username:走自动登录(密码 123456),成功/失败都进 /home/chat
  if (username) {
    http({
      url: "/login",
      method: 'post',
      data: {
        terminal: 0,
        userName: username,
        password: "123456"
      }
    }).then((data) => {
      auth.saveLoginSession(data, { autoLogin: true, userName: username });
      removeSearchUsername();
      next({ path: '/home/chat', replace: true });
    }).catch(() => {
      removeSearchUsername();
      next('/home/chat');
    });
    return;
  }
  // 无 username:已登录(有 accessToken)则正常放行,允许 chat/friend/group 间导航
  const hasToken = !!sessionStorage.getItem('accessToken');
  if (hasToken) {
    next();
    return;
  }
  // 未登录:强制进 /home/chat,不跳 login;已在 chat 则放行避免死循环
  if (to.path === '/home/chat') {
    next();
  } else {
    next('/home/chat');
  }
});

export default router;
